import {z} from 'zod';
import {stringToJSONSchema} from '@netx/core-next/schema/utils';

/*
// server response
{
    goo: "{\\\"label\\\":\\\"\\\",\\\"actions\\\":[\\\"app:contact\\\",\\\"cms:route:category:root\\\",{\\\"label\\\":\\\"New submenu\\\",\\\"actions\\\":[\\\"cms:action:1:fPrtxF9YrE\\\",\\\"cms:route:category:root\\\"]}]}"
    id: 1
    modDate: "2019-09-20 16:46:40"
    name: "main"
    portalId: 1
    userId: 0
}
*/

export const BRAND_PORTAL_MENU_GOO_KEYS = ['label', 'actions'] as const;

export const BrandPortalMenuSchema = z.object({
	id: z.number().int().positive(),
	/** ex 2019-09-20 16:46:40 */
	modDate: z.string(),
	name: z.string(),
	portalId: z.number().int().positive(),
	userId: z.number().int().positive(),
	goo: stringToJSONSchema.pipe(
		z.object({
			label: z.string(),
			actions: z.array(
				z.union([
					z.string(),
					z.object({
						label: z.string(),
						actions: z.array(z.string()),
					}),
				]),
			),
		}),
	),
});

export const BrandPortalMenuRawSchema = BrandPortalMenuSchema.omit({
	goo: true,
}).extend({
	goo: z.string(),
});

export type IBrandPortalMenu = z.infer<typeof BrandPortalMenuSchema>;

export type IBrandPortalMenuRaw = z.infer<typeof BrandPortalMenuRawSchema>;
